module.exports = __webpack_public_path__ + "static/media/pediatric.b58bce41.svg";